import { useTranslation } from 'react-i18next'

import { Loader } from '@percent/cause-dashboard/common/components'
import { EmptyState } from '@percent/cause-dashboard/app/common/components/emptyState/EmptyState'
import { useSavingsCalculatorStory } from '@percent/cause-dashboard/storyblok/savings-calculator/useSavingsCalculatorStory'

import styles from './SavingsCalculator.module.scss'
import { SavingsCalculatorSteps } from './SavingsCalculatorSteps'
import { SavingsCalculatorSurface } from './SavingsCalculator.types'

type SavingsCalculatorContentProps = {
  surface: SavingsCalculatorSurface
  source?: string
  onComplete: VoidFunction
}

export function SavingsCalculatorContent({ surface, source, onComplete }: SavingsCalculatorContentProps) {
  const { t } = useTranslation()
  const { partners, loading, error } = useSavingsCalculatorStory()

  if (loading) {
    return (
      <div className={styles.stateWrapper} data-testid="savings-calculator-loading">
        <Loader isFullScreen={false} />
      </div>
    )
  }

  if (error || partners.length === 0) {
    return (
      <div className={styles.stateWrapper}>
        <EmptyState
          illustration="no-search-results"
          title={t('savingsCalculator.unavailable.title')}
          description={t('savingsCalculator.unavailable.description')}
        />
      </div>
    )
  }

  return (
    <SavingsCalculatorSteps partners={partners} surface={surface} source={source} onComplete={onComplete} />

  )
}
